import { render, staticRenderFns } from "./SupplierDomains.vue?vue&type=template&id=29a012eb&"
import script from "./SupplierDomains.vue?vue&type=script&lang=js&"
export * from "./SupplierDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports